import { SupportTicketMapper } from '../SupportTicketMapper.js';
import { SupportTicketCommonDataMapper } from '../SupportTicketCommonData/SupportTicketCommonData.js';

class DeliverySupportTicketMapper {
  static createModelFromResponse(response) {
    return {
      ...SupportTicketMapper.createModelFromResponse(response),
      ...SupportTicketCommonDataMapper.createModelFromResponse(response.delivery),
      shipmentReference: response.shipment_reference
    };
  }
  static createApiPayload(_ref) {
    let {
      shipmentReference,
      reason,
      additionalPicture
    } = _ref;
    return {
      shipment_reference: shipmentReference,
      delivery: SupportTicketCommonDataMapper.createApiPayload({
        reason,
        additionalPicture
      })
    };
  }
}

export { DeliverySupportTicketMapper };
//# sourceMappingURL=DeliverySupportTicketMapper.js.map
